export default (schedules: App.OfferVisibilityScheduleMap, regionCode: string) => schedules[regionCode] || schedules.world
